import { PaymentMethodEnum } from "../models/types.mjs";

// src/utils/coachConsultationBooking.ts
function coachConsultationStartTime(consult) {
	const startTime = consult.startTime;
	if (!startTime) return null;
	return startTime instanceof Date ? startTime : new Date(startTime);
}
function isFutureCoachConsultation(consult, now = /* @__PURE__ */ new Date()) {
	const startTime = coachConsultationStartTime(consult);
	if (!startTime) return false;
	return startTime.getTime() > now.getTime();
}
function hasFutureCoachConsultation(consults, now = /* @__PURE__ */ new Date()) {
	return consults.some((consult) => isFutureCoachConsultation(consult, now));
}
function hasCoachConsultationForProgram(consults, referralProgramId) {
	return consults.some((consult) => consult.referralProgramId === referralProgramId);
}
function getLatestCoachConsultationByBookedAt(consults) {
	if (consults.length === 0) return null;
	return [...consults].sort((left, right) => {
		const leftBookedAt = left.bookedAt?.getTime() ?? 0;
		return (right.bookedAt?.getTime() ?? 0) - leftBookedAt;
	})[0];
}
function validateCoachConsultationBooking(params) {
	const { existingConsults, referralProgramId, programPaymentMethod, programConsultationIncluded, now = /* @__PURE__ */ new Date() } = params;
	if (hasFutureCoachConsultation(existingConsults, now)) return {
		allowed: false,
		reason: "future-consult-exists"
	};
	if (referralProgramId) {
		if (programPaymentMethod !== "sponsored") return {
			allowed: false,
			reason: "program-not-sponsored"
		};
		if (!programConsultationIncluded) return {
			allowed: false,
			reason: "program-consult-not-included"
		};
		if (hasCoachConsultationForProgram(existingConsults, referralProgramId)) return {
			allowed: false,
			reason: "program-already-booked"
		};
	}
	return { allowed: true };
}

export { coachConsultationStartTime, getLatestCoachConsultationByBookedAt, hasCoachConsultationForProgram, hasFutureCoachConsultation, isFutureCoachConsultation, validateCoachConsultationBooking };
//# sourceMappingURL=coachConsultationBooking.mjs.map